import { getMultiAdsAreaRange } from './getMultiAdsAreaRange';
import { getMultiAdsTypePlural } from './getMultiAdsTypePlural';
import { isCommercialMultiAds } from './isCommercialMultiAds';
import { IOffer } from '../../../../types/offer';

const MIDDLE_DOT = '・';

export function getMultiAdsSubtitle(offer: IOffer): string | undefined {
  if (!isCommercialMultiAds(offer)) {
    return undefined;
  }

  const typePlural = getMultiAdsTypePlural(offer);
  const areaRange = getMultiAdsAreaRange(offer);

  if (typePlural && areaRange) {
    return `${typePlural}${MIDDLE_DOT}${areaRange}`;
  }

  return typePlural ?? areaRange;
}
